<template>
    <dialog-selector
        class="membercard-dialog-selector"
        ref="dialogSelector"
        title="选择会员卡"
        v-on="$listeners"
        v-bind="$attrs"
        :data="groupData"
        :showSidebar="false"
        search-placeholder="输入关键字检索会员卡"
        :props="{ label: options.nameKey }"
        :disabled-collapse="true">
        <template v-slot:node="{ node }" class="test">
            <div class="selector-custom-item">
                <span class="selector-custom-item__name" :title="node[options.nameKey]">{{ node[options.nameKey] | cutString(14) }}</span>
                <span class="selector-custom-item__price" :title="node.no">
                    <span>￥</span>
                    {{ node[options.priceKey] || 0 }}
                </span>
            </div>
        </template>
    </dialog-selector>
</template>

<script>
    import DialogSelector from '@/components/dialog-selector';
    import UtilsMixins from '@/mixins/utils'
    export default {
        name: 'MemberCardDialogSelector',
        mixins: [UtilsMixins],
        components: {
            DialogSelector,
        },
        props: {
            groupData: {
                type: Array,
                default: () => []
            },
            options: {
                type: Object,
                default: () => {
                    return { nameKey: 'label', priceKey: 'price' }
                }
            }
        },
        data() {
            return {
                selectGroupId: null,
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="scss">
.membercard-dialog-selector {
    .dialog-selector__content {
        height: 370px;
    }
    .selector-custom-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.unactive {
            .selector-custom-item__price,
            .dialog-selector__item, 
            .selector-custom-item__name {
                color: #999;
            }
        }
    }
    .selector-custom-item__price {
        color: #F83051;
    }
    .dialog-selector__item {
        margin-right: 30px;
        flex: 0 0 calc(33.3% - 30px);
    }
}
</style>
